export default "__VITE_ASSET__BXSokaqy__"